import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";


class KonuBasligiListeAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "KonuBasligiListe";
    super(baseUrl);
  }


  getKonuBasligiListeListe(konuBasligiKodu?: number){
    
        var request= new KonuBasligiListeListeRequest(konuBasligiKodu);
    return this.get("", request);
   
  }

}
export default new KonuBasligiListeAPI();
class KonuBasligiListeListeRequest {
  public konuBasligiKodu?: number;
 
  constructor(konuBasligiKodu?: number,) {
    this.konuBasligiKodu = konuBasligiKodu;

   
  }
}
export { KonuBasligiListeListeRequest };